import styled from 'styled-components';

export const StyledForm = styled('form')`
  margin-top: ${({ theme }) => `${theme.x1spacePx}px`};
`;

export const FieldWrapper = styled('div')`
  position: relative;
  margin-bottom: ${({ theme }) => `${theme.x1spacePx}px`};
`;
